import { EMergeCategory } from '../types/enums/merge-category';
import { EMergeType } from '../types/enums/merge-type';
import { IMergeFieldProperty } from '@/dealroom/fields/merge-field/types/merge-field-property';

export const mergeFieldProperties: IMergeFieldProperty[] = [
  {
    name: 'document-name',
    type: EMergeType.DocumentName,
    category: EMergeCategory.Document,
  },
  {
    name: 'document-value',
    type: EMergeType.DocumentValue,
    category: EMergeCategory.Document,
  },
  {
    name: 'send-date',
    type: EMergeType.SendDate,
    category: EMergeCategory.Document,
  },
  {
    name: 'unique-id',
    type: EMergeType.UniqueId,
    category: EMergeCategory.Document,
  },
  {
    name: 'sender-name',
    type: EMergeType.SenderName,
    category: EMergeCategory.Sender,
  },
  {
    name: 'sender-first-name',
    type: EMergeType.SenderFirstName,
    category: EMergeCategory.Sender,
  },
  {
    name: 'sender-last-name',
    type: EMergeType.SenderLastName,
    category: EMergeCategory.Sender,
  },
  {
    name: 'sender-title',
    type: EMergeType.SenderTitle,
    category: EMergeCategory.Sender,
  },
  {
    name: 'sender-email',
    type: EMergeType.SenderEmail,
    category: EMergeCategory.Sender,
  },
  {
    name: 'sender-mobile',
    type: EMergeType.SenderMobile,
    category: EMergeCategory.Sender,
  },
  {
    name: 'sender-company',
    type: EMergeType.SenderCompanyName,
    category: EMergeCategory.Sender,
  },
  {
    name: 'sender-organisation-number',
    type: EMergeType.SenderOrganisationNumber,
    category: EMergeCategory.Sender,
  },
  {
    name: 'recipient-name',
    type: EMergeType.RecipientName,
    category: EMergeCategory.Recipient,
  },
  {
    name: 'recipient-first-name',
    type: EMergeType.RecipientFirstName,
    category: EMergeCategory.Recipient,
  },
  {
    name: 'recipient-last-name',
    type: EMergeType.RecipientLastName,
    category: EMergeCategory.Recipient,
  },
  {
    name: 'recipient-title',
    type: EMergeType.RecipientTitle,
    category: EMergeCategory.Recipient,
  },
  {
    name: 'recipient-email',
    type: EMergeType.RecipientEmail,
    category: EMergeCategory.Recipient,
  },
  {
    name: 'recipient-mobile',
    type: EMergeType.RecipientMobile,
    category: EMergeCategory.Recipient,
  },
  {
    name: 'recipient-company',
    type: EMergeType.RecipientCompanyName,
    category: EMergeCategory.Recipient,
  },
  {
    name: 'recipient-organisation-number',
    type: EMergeType.RecipientOrganisationNumber,
    category: EMergeCategory.Recipient,
  },
  {
    name: 'sign-date-standard',
    type: EMergeType.SignDateStandard,
    category: EMergeCategory.Signing,
  },
  {
    name: 'sign-date-short',
    type: EMergeType.SignDateShort,
    category: EMergeCategory.Signing,
  },
  {
    name: 'sign-date-long',
    type: EMergeType.SignDateLong,
    category: EMergeCategory.Signing,
  },
  {
    name: 'custom',
    type: EMergeType.Custom,
    category: EMergeCategory.Custom,
  },
];
